import { AccountHeader } from "@/components/account/AccountHeader";
import { ProfileForm } from "@/components/account/ProfileForm";
import { PasswordReset } from "@/components/account/PasswordReset";
import { SubscriptionInfo } from "@/components/account/SubscriptionInfo";
import { DeleteAccount } from "@/components/account/DeleteAccount";
import { memo } from "react";

const Account = memo(() => {
  console.log("Account page rendered");

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8">
      <div className="mx-auto max-w-2xl">
        <AccountHeader />
        
        <div className="mt-8 space-y-6">
          <section className="bg-white shadow-sm rounded-lg p-6">
            <ProfileForm />
          </section>
          
          <SubscriptionInfo />
          
          <section className="bg-white shadow-sm rounded-lg p-6">
            <PasswordReset />
            <DeleteAccount />
          </section>
        </div>
      </div>
    </div>
  );
});

Account.displayName = 'Account';

export default Account;